export const PAGES = {
    LOADING:                                'loading',
    PERSONAL_DETAILS:                       'personal-details',
    CLIENT_DETAILS :                        'client-details',
    ISA_DETAILS:                            'isa-details',
    DECLARATION:                            'declaration',
    BANK_DETAILS:                           'bank-details',
    TAX_DETAILS:                            'tax-details',
    REVIEW_APPLICATION:                     'review-application',
    INFORMATION_CERTIFICATION_AGREEMENT:    'information-certification-agreement',
    CONGRATULATIONS:                        'congratulations',
}

export const BOOLEAN_OPTIONS = [
    {
        label: 'Yes',
        value: 1
    }, {
        label: 'No',
        value: 0
    },
];

export const DATE_FORMATS = {
    DATE:           "dd/MM/yyyy",
    DATETIME:       "dd/MM/yyyy HH:mm:ss",
    DATE_KEY:       "yyyyMMdd",
    TIME:           "HH:mm:ss",
    HOUR_MINUTE:    "HH:mm",
    DB:             "yyyy-MM-dd HH:mm:ss",
    DB_DATE:        "yyyy-MM-dd",
    HOURS:          "HH",
    MINUTES:        "mm",
    SECONDS:        "t",
    MILLISECONDS:   "T",
}

export const ADVISOR_AUTHORIZED_FOR_OPTIONS = [
    {
        label: 'Controlling Akoni Hub Platform Account',
        value: 'Controlling Akoni Hub Platform Account'
    }, {
        label: 'View Only',
        value: 'View Only'
    },
];

export const fees_payments = [
    {
        label: 'Direct Debit',
        value: 'Direct Debit'
    }, {
        label: 'By Invoice',
        value: 'By Invoice'
    },
];

export const SOURCE_OF_FUNDS_OPTIONS = [
    {
        label: 'Savings from salary',
        value: 'Savings from salary'
    }, {
        label: 'Sales of shares or other investments',
        value: 'Sales of shares or other investments'
    }, {
        label: 'Sale of property',
        value: 'Sale of property'
    }, {
        label: 'Inheritance',
        value: 'Inheritance'
    }, {
        label: 'Company sale',
        value: 'Company sale'
    }, {
        label: 'Company profit',
        value: 'Company profit'
    }, {
        label: 'Gift',
        value: 'Gift'
    }, {
        label: 'Other',
        value: 'Other'
    },
];

export const OPENING        = 'Opening';
export const TRANSFERRING   = 'Transferring';

export const OPENING_OR_TRANSFERRING = [
    {
        label: 'Opening',
        value: 'Opening'
    }, {
        label: 'Transferring',
        value: 'Transferring'
    },
];

export const ISA_TYPES = [
    {
        label: 'Cash ISA',
        value: 'Cash ISA',
    }, {
        label: 'Stocks and Shares ISA',
        value: 'Stocks and Shares ISA',
    }, {
        label: 'Innovative Finance ISA',
        value: 'Innovative Finance ISA',
    }, {
        label: 'Lifetime ISA',
        value: 'Lifetime ISA',
    }
]

export const TITLE_OPTIONS = [
    {
        label: 'Mr',
        value: 'Mr',
    }, {
        label: 'Mrs',
        value: 'Mrs',
    }, {
        label: 'Miss',
        value: 'Miss',
    }, {
        label: 'Mz',
        value: 'Mz',
    }, {
        label: 'Mx',
        value: 'Mx',
    }
]

export const PHONE_PREFIX_OPTIONS = [
    {
        label: '+1',
        value: '+1'
    },
    {
        label: '+7',
        value: '+7'
    },
    {
        label: '+20',
        value: '+20'
    },
    {
        label: '+27',
        value: '+27'
    },
    {
        label: '+30',
        value: '+30'
    },
    {
        label: '+31',
        value: '+31'
    },
    {
        label: '+32',
        value: '+32'
    },
    {
        label: '+33',
        value: '+33'
    },
    {
        label: '+34',
        value: '+34'
    },
    {
        label: '+36',
        value: '+36'
    },
    {
        label: '+39',
        value: '+39'
    },
    {
        label: '+40',
        value: '+40'
    },
    {
        label: '+41',
        value: '+41'
    },
    {
        label: '+43',
        value: '+43'
    },
    {
        label: '+44',
        value: '+44'
    },
    {
        label: '+45',
        value: '+45'
    },
    {
        label: '+46',
        value: '+46'
    },
    {
        label: '+47',
        value: '+47'
    },
    {
        label: '+48',
        value: '+48'
    },
    {
        label: '+49',
        value: '+49'
    },
    {
        label: '+52',
        value: '+52'
    },
    {
        label: '+54',
        value: '+54'
    },
    {
        label: '+55',
        value: '+55'
    },
    {
        label: '+56',
        value: '+56'
    },
    {
        label: '+57',
        value: '+57'
    },
    {
        label: '+58',
        value: '+58'
    },
    {
        label: '+60',
        value: '+60'
    },
    {
        label: '+61',
        value: '+61'
    },
    {
        label: '+62',
        value: '+62'
    },
    {
        label: '+63',
        value: '+63'
    },
    {
        label: '+64',
        value: '+64'
    },
    {
        label: '+65',
        value: '+65'
    },
    {
        label: '+66',
        value: '+66'
    },
    {
        label: '+81',
        value: '+81'
    },
    {
        label: '+82',
        value: '+82'
    },
    {
        label: '+84',
        value: '+84'
    },
    {
        label: '+86',
        value: '+86'
    },
    {
        label: '+90',
        value: '+90'
    },
    {
        label: '+91',
        value: '+91'
    },
    {
        label: '+92',
        value: '+92'
    },
    {
        label: '+93',
        value: '+93'
    },
    {
        label: '+94',
        value: '+94'
    },
    {
        label: '+95',
        value: '+95'
    },
    {
        label: '+98',
        value: '+98'
    },
    {
        label: '+211',
        value: '+211'
    },
    {
        label: '+212',
        value: '+212'
    },
    {
        label: '+213',
        value: '+213'
    },
    {
        label: '+216',
        value: '+216'
    },
    {
        label: '+218',
        value: '+218'
    },
    {
        label: '+220',
        value: '+220'
    },
    {
        label: '+221',
        value: '+221'
    },
    {
        label: '+222',
        value: '+222'
    },
    {
        label: '+223',
        value: '+223'
    },
    {
        label: '+224',
        value: '+224'
    },
    {
        label: '+225',
        value: '+225'
    },
    {
        label: '+226',
        value: '+226'
    },
    {
        label: '+227',
        value: '+227'
    },
    {
        label: '+228',
        value: '+228'
    },
    {
        label: '+229',
        value: '+229'
    },
    {
        label: '+230',
        value: '+230'
    },
    {
        label: '+231',
        value: '+231'
    },
    {
        label: '+232',
        value: '+232'
    },
    {
        label: '+233',
        value: '+233'
    },
    {
        label: '+234',
        value: '+234'
    },
    {
        label: '+235',
        value: '+235'
    },
    {
        label: '+236',
        value: '+236'
    },
    {
        label: '+237',
        value: '+237'
    },
    {
        label: '+238',
        value: '+238'
    },
    {
        label: '+239',
        value: '+239'
    },
    {
        label: '+240',
        value: '+240'
    },
    {
        label: '+241',
        value: '+241'
    },
    {
        label: '+242',
        value: '+242'
    },
    {
        label: '+243',
        value: '+243'
    },
    {
        label: '+244',
        value: '+244'
    },
    {
        label: '+245',
        value: '+245'
    },
    {
        label: '+246',
        value: '+246'
    },
    {
        label: '+247',
        value: '+247'
    },
    {
        label: '+248',
        value: '+248'
    },
    {
        label: '+249',
        value: '+249'
    },
    {
        label: '+250',
        value: '+250'
    },
    {
        label: '+251',
        value: '+251'
    },
    {
        label: '+252',
        value: '+252'
    },
    {
        label: '+253',
        value: '+253'
    },
    {
        label: '+254',
        value: '+254'
    },
    {
        label: '+255',
        value: '+255'
    },
    {
        label: '+256',
        value: '+256'
    },
    {
        label: '+257',
        value: '+257'
    },
    {
        label: '+258',
        value: '+258'
    },
    {
        label: '+260',
        value: '+260'
    },
    {
        label: '+261',
        value: '+261'
    },
    {
        label: '+262',
        value: '+262'
    },
    {
        label: '+263',
        value: '+263'
    },
    {
        label: '+264',
        value: '+264'
    },
    {
        label: '+265',
        value: '+265'
    },
    {
        label: '+266',
        value: '+266'
    },
    {
        label: '+267',
        value: '+267'
    },
    {
        label: '+268',
        value: '+268'
    },
    {
        label: '+269',
        value: '+269'
    },
    {
        label: '+290',
        value: '+290'
    },
    {
        label: '+291',
        value: '+291'
    },
    {
        label: '+297',
        value: '+297'
    },
    {
        label: '+298',
        value: '+298'
    },
    {
        label: '+299',
        value: '+299'
    },
    {
        label: '+350',
        value: '+350'
    },
    {
        label: '+351',
        value: '+351'
    },
    {
        label: '+352',
        value: '+352'
    },
    {
        label: '+353',
        value: '+353'
    },
    {
        label: '+354',
        value: '+354'
    },
    {
        label: '+355',
        value: '+355'
    },
    {
        label: '+356',
        value: '+356'
    },
    {
        label: '+357',
        value: '+357'
    },
    {
        label: '+358',
        value: '+358'
    },
    {
        label: '+359',
        value: '+359'
    },
    {
        label: '+370',
        value: '+370'
    },
    {
        label: '+371',
        value: '+371'
    },
    {
        label: '+372',
        value: '+372'
    },
    {
        label: '+373',
        value: '+373'
    },
    {
        label: '+374',
        value: '+374'
    },
    {
        label: '+375',
        value: '+375'
    },
    {
        label: '+376',
        value: '+376'
    },
    {
        label: '+377',
        value: '+377'
    },
    {
        label: '+378',
        value: '+378'
    },
    {
        label: '+379',
        value: '+379'
    },
    {
        label: '+380',
        value: '+380'
    },
    {
        label: '+381',
        value: '+381'
    },
    {
        label: '+382',
        value: '+382'
    },
    {
        label: '+383',
        value: '+383'
    },
    {
        label: '+385',
        value: '+385'
    },
    {
        label: '+386',
        value: '+386'
    },
    {
        label: '+387',
        value: '+387'
    },
    {
        label: '+389',
        value: '+389'
    },
    {
        label: '+420',
        value: '+420'
    },
    {
        label: '+421',
        value: '+421'
    },
    {
        label: '+423',
        value: '+423'
    },
    {
        label: '+500',
        value: '+500'
    },
    {
        label: '+501',
        value: '+501'
    },
    {
        label: '+502',
        value: '+502'
    },
    {
        label: '+503',
        value: '+503'
    },
    {
        label: '+504',
        value: '+504'
    },
    {
        label: '+505',
        value: '+505'
    },
    {
        label: '+506',
        value: '+506'
    },
    {
        label: '+507',
        value: '+507'
    },
    {
        label: '+508',
        value: '+508'
    },
    {
        label: '+509',
        value: '+509'
    },
    {
        label: '+590',
        value: '+590'
    },
    {
        label: '+591',
        value: '+591'
    },
    {
        label: '+592',
        value: '+592'
    },
    {
        label: '+593',
        value: '+593'
    },
    {
        label: '+594',
        value: '+594'
    },
    {
        label: '+595',
        value: '+595'
    },
    {
        label: '+596',
        value: '+596'
    },
    {
        label: '+597',
        value: '+597'
    },
    {
        label: '+598',
        value: '+598'
    },
    {
        label: '+599',
        value: '+599'
    },
    {
        label: '+670',
        value: '+670'
    },
    {
        label: '+672',
        value: '+672'
    },
    {
        label: '+673',
        value: '+673'
    },
    {
        label: '+674',
        value: '+674'
    },
    {
        label: '+675',
        value: '+675'
    },
    {
        label: '+676',
        value: '+676'
    },
    {
        label: '+677',
        value: '+677'
    },
    {
        label: '+678',
        value: '+678'
    },
    {
        label: '+679',
        value: '+679'
    },
    {
        label: '+680',
        value: '+680'
    },
    {
        label: '+681',
        value: '+681'
    },
    {
        label: '+682',
        value: '+682'
    },
    {
        label: '+683',
        value: '+683'
    },
    {
        label: '+685',
        value: '+685'
    },
    {
        label: '+686',
        value: '+686'
    },
    {
        label: '+687',
        value: '+687'
    },
    {
        label: '+688',
        value: '+688'
    },
    {
        label: '+689',
        value: '+689'
    },
    {
        label: '+690',
        value: '+690'
    },
    {
        label: '+691',
        value: '+691'
    },
    {
        label: '+692',
        value: '+692'
    },
    {
        label: '+850',
        value: '+850'
    },
    {
        label: '+852',
        value: '+852'
    },
    {
        label: '+853',
        value: '+853'
    },
    {
        label: '+855',
        value: '+855'
    },
    {
        label: '+856',
        value: '+856'
    },
    {
        label: '+880',
        value: '+880'
    },
    {
        label: '+886',
        value: '+886'
    },
    {
        label: '+960',
        value: '+960'
    },
    {
        label: '+961',
        value: '+961'
    },
    {
        label: '+962',
        value: '+962'
    },
    {
        label: '+963',
        value: '+963'
    },
    {
        label: '+964',
        value: '+964'
    },
    {
        label: '+965',
        value: '+965'
    },
    {
        label: '+966',
        value: '+966'
    },
    {
        label: '+967',
        value: '+967'
    },
    {
        label: '+968',
        value: '+968'
    },
    {
        label: '+970',
        value: '+970'
    },
    {
        label: '+971',
        value: '+971'
    },
    {
        label: '+972',
        value: '+972'
    },
    {
        label: '+973',
        value: '+973'
    },
    {
        label: '+974',
        value: '+974'
    },
    {
        label: '+975',
        value: '+975'
    },
    {
        label: '+976',
        value: '+976'
    },
    {
        label: '+977',
        value: '+977'
    },
    {
        label: '+979',
        value: '+979'
    },
    {
        label: '+994',
        value: '+994'
    },
    {
        label: '+995',
        value: '+995'
    },
    {
        label: '+996',
        value: '+996'
    },
    {
        label: '+998',
        value: '+998'
    }
];

export const MONTH_OPTIONS = [
    {
        label: 'Jan',
        value: '01'
    }, {
        label: 'Feb',
        value: '02'
    }, {
        label: 'Mar',
        value: '03'
    }, {
        label: 'Apr',
        value: '04'
    }, {
        label: 'May',
        value: '05'
    }, {
        label: 'Jun',
        value: '06'
    }, {
        label: 'Jul',
        value: '07'
    }, {
        label: 'Aug',
        value: '08'
    }, {
        label: 'Sep',
        value: '09'
    }, {
        label: 'Oct',
        value: '10'
    }, {
        label: 'Nov',
        value: '11'
    }, {
        label: 'Dec',
        value: '12'
    }
];

export const YEAR_OPTIONS = [
    {
        label: '2023',
        value: '2023'
    }, {
        label: '2022',
        value: '2022'
    }, {
        label: '2021',
        value: '2021'
    }, {
        label: '2020',
        value: '2020'
    }, {
        label: '2019',
        value: '2019'
    }, {
        label: '2018',
        value: '2018'
    }, {
        label: '2017',
        value: '2017'
    }, {
        label: '2016',
        value: '2016'
    }, {
        label: '2015',
        value: '2015'
    }, {
        label: '2014',
        value: '2014'
    }, {
        label: '2013',
        value: '2013'
    }, {
        label: '2012',
        value: '2012'
    }, {
        label: '2011',
        value: '2011'
    }, {
        label: '2010',
        value: '2010'
    }, {
        label: '2009',
        value: '2009'
    }, {
        label: '2008',
        value: '2008'
    }, {
        label: '2007',
        value: '2007'
    }, {
        label: '2006',
        value: '2006'
    }, {
        label: '2005',
        value: '2005'
    }, {
        label: '2004',
        value: '2004'
    }, {
        label: '2003',
        value: '2003'
    }, {
        label: '2002',
        value: '2002'
    }, {
        label: '2001',
        value: '2001'
    }, {
        label: '2000',
        value: '2000'
    }, {
        label: '1999',
        value: '1999'
    }, {
        label: '1998',
        value: '1998'
    }, {
        label: '1997',
        value: '1997'
    }, {
        label: '1996',
        value: '1996'
    }, {
        label: '1995',
        value: '1995'
    }, {
        label: '1994',
        value: '1994'
    }, {
        label: '1993',
        value: '1993'
    }, {
        label: '1992',
        value: '1992'
    }, {
        label: '1991',
        value: '1991'
    }, {
        label: '1990',
        value: '1990'
    }, {
        label: '1989',
        value: '1989'
    }, {
        label: '1988',
        value: '1988'
    }, {
        label: '1987',
        value: '1987'
    }, {
        label: '1986',
        value: '1986'
    }, {
        label: '1985',
        value: '1985'
    }, {
        label: '1984',
        value: '1984'
    }, {
        label: '1983',
        value: '1983'
    }, {
        label: '1982',
        value: '1982'
    }, {
        label: '1981',
        value: '1981'
    }, {
        label: '1980',
        value: '1980'
    }, {
        label: '1979',
        value: '1979'
    }, {
        label: '1978',
        value: '1978'
    }, {
        label: '1977',
        value: '1977'
    }, {
        label: '1976',
        value: '1976'
    }, {
        label: '1975',
        value: '1975'
    }, {
        label: '1974',
        value: '1974'
    }
];

export const NATIONALITY_OPTIONS = [
    {
        label: 'British',
        value: 'British'
    }, {
        label: 'Irish',
        value: 'Irish'
    }, {
        label: 'Afghan',
        value: 'Afghan'
    }, {
        label: 'Albanian',
        value: 'Albanian'
    }, {
        label: 'Algerian',
        value: 'Algerian'
    }, {
        label: 'American',
        value: 'American'
    }, {
        label: 'American Samoan',
        value: 'American Samoan'
    }, {
        label: 'Andorran',
        value: 'Andorran'
    }, {
        label: 'Angolan',
        value: 'Angolan'
    }, {
        label: 'Anguillan',
        value: 'Anguillan'
    }, {
        label: 'Antarctic',
        value: 'Antarctic'
    }, {
        label: 'Antiguan or Barbudan',
        value: 'Antiguan or Barbudan'
    }, {
        label: 'Argentine',
        value: 'Argentine'
    }, {
        label: 'Armenian',
        value: 'Armenian'
    }, {
        label: 'Aruban',
        value: 'Aruban'
    }, {
        label: 'Australian',
        value: 'Australian'
    }, {
        label: 'Austrian',
        value: 'Austrian'
    }, {
        label: 'Azerbaijani',
        value: 'Azerbaijani'
    }, {
        label: 'Azeri',
        value: 'Azeri'
    }, {
        label: 'Bahamian',
        value: 'Bahamian'
    }, {
        label: 'Bahraini',
        value: 'Bahraini'
    }, {
        label: 'Bangladeshi',
        value: 'Bangladeshi'
    }, {
        label: 'Barbadian',
        value: 'Barbadian'
    }, {
        label: 'Barthélemois',
        value: 'Barthélemois'
    }, {
        label: 'Basotho',
        value: 'Basotho'
    }, {
        label: 'Belarusian',
        value: 'Belarusian'
    }, {
        label: 'Belgian',
        value: 'Belgian'
    }, {
        label: 'Belizean',
        value: 'Belizean'
    }, {
        label: 'Beninese',
        value: 'Beninese'
    }, {
        label: 'Beninois',
        value: 'Beninois'
    }, {
        label: 'Bermudian',
        value: 'Bermudian'
    }, {
        label: 'Bermudan',
        value: 'Bermudan'
    }, {
        label: 'Bhutanese',
        value: 'Bhutanese'
    }, {
        label: 'BIOT',
        value: 'BIOT'
    }, {
        label: 'Bissau-Guinean',
        value: 'Bissau-Guinean'
    }, {
        label: 'Bolivian',
        value: 'Bolivian'
    }, {
        label: 'Bonaire',
        value: 'Bonaire'
    }, {
        label: 'Bosnian or Herzegovinian',
        value: 'Bosnian or Herzegovinian'
    }, {
        label: 'Bouvet Island',
        value: 'Bouvet Island'
    }, {
        label: 'Brazilian',
        value: 'Brazilian'
    }, {
        label: 'British Virgin Island',
        value: 'British Virgin Island'
    }, {
        label: 'Bruneian',
        value: 'Bruneian'
    }, {
        label: 'Bulgarian',
        value: 'Bulgarian'
    }, {
        label: 'Burkinabé',
        value: 'Burkinabé'
    }, {
        label: 'Burmese',
        value: 'Burmese'
    }, {
        label: 'Burundian',
        value: 'Burundian'
    }, {
        label: 'Cabo Verdean',
        value: 'Cabo Verdean'
    }, {
        label: 'Cambodian',
        value: 'Cambodian'
    }, {
        label: 'Cameroonian',
        value: 'Cameroonian'
    }, {
        label: 'Canadian',
        value: 'Canadian'
    }, {
        label: 'Caymanian',
        value: 'Caymanian'
    }, {
        label: 'Central African',
        value: 'Central African'
    }, {
        label: 'Chadian',
        value: 'Chadian'
    }, {
        label: 'Channel Island (GGY)',
        value: 'Channel Island (GGY)'
    }, {
        label: 'Channel Island (JEY)',
        value: 'Channel Island (JEY)'
    }, {
        label: 'Chilean',
        value: 'Chilean'
    }, {
        label: 'Chinese',
        value: 'Chinese'
    }, {
        label: 'Christmas Island',
        value: 'Christmas Island'
    }, {
        label: 'Cocos Island',
        value: 'Cocos Island'
    }, {
        label: 'Colombian',
        value: 'Colombian'
    }, {
        label: 'Comoran',
        value: 'Comoran'
    }, {
        label: 'Congolese',
        value: 'Congolese'
    }, {
        label: 'Congolese (Congo)',
        value: 'Congolese (Congo)'
    }, {
        label: 'Cook Island',
        value: 'Cook Island'
    }, {
        label: 'Costa Rican',
        value: 'Costa Rican'
    }, {
        label: 'Croatian',
        value: 'Croatian'
    }, {
        label: 'Cuban',
        value: 'Cuban'
    }, {
        label: 'Curaçaoan',
        value: 'Curaçaoan'
    }, {
        label: 'Cypriot',
        value: 'Cypriot'
    }, {
        label: 'Czech',
        value: 'Czech'
    }, {
        label: 'Danish',
        value: 'Danish'
    }, {
        label: 'Djiboutian',
        value: 'Djiboutian'
    }, {
        label: 'Dominican',
        value: 'Dominican'
    }, {
        label: 'Dominican (Commonwealth)',
        value: 'Dominican (Commonwealth)'
    }, {
        label: 'Dutch',
        value: 'Dutch'
    }, {
        label: 'Dutch Antillean',
        value: 'Dutch Antillean'
    }, {
        label: 'East Timorese',
        value: 'East Timorese'
    }, {
        label: 'Ecuadorean',
        value: 'Ecuadorean'
    }, {
        label: 'Egyptian',
        value: 'Egyptian'
    }, {
        label: 'Emirati',
        value: 'Emirati'
    }, {
        label: 'Equatorial Guinean',
        value: 'Equatorial Guinean'
    }, {
        label: 'Eritrean',
        value: 'Eritrean'
    }, {
        label: 'Estonian',
        value: 'Estonian'
    }, {
        label: 'Eswatini',
        value: 'Eswatini'
    }, {
        label: 'Ethiopian',
        value: 'Ethiopian'
    }, {
        label: 'Falkland Island',
        value: 'Falkland Island'
    }, {
        label: 'Faroese',
        value: 'Faroese'
    }, {
        label: 'Fijian',
        value: 'Fijian'
    }, {
        label: 'Filipino',
        value: 'Filipino'
    }, {
        label: 'Finnish',
        value: 'Finnish'
    }, {
        label: 'French',
        value: 'French'
    }, {
        label: 'French Guianese',
        value: 'French Guianese'
    }, {
        label: 'French Polynesian',
        value: 'French Polynesian'
    }, {
        label: 'French Southern Territories',
        value: 'French Southern Territories'
    }, {
        label: 'Gabonese',
        value: 'Gabonese'
    }, {
        label: 'Gambian',
        value: 'Gambian'
    }, {
        label: 'Georgian',
        value: 'Georgian'
    }, {
        label: 'German',
        value: 'German'
    }, {
        label: 'Ghanaian',
        value: 'Ghanaian'
    }, {
        label: 'Gibraltar',
        value: 'Gibraltar'
    }, {
        label: 'Greek',
        value: 'Greek'
    }, {
        label: 'Greenlandic',
        value: 'Greenlandic'
    }, {
        label: 'Grenadian',
        value: 'Grenadian'
    }, {
        label: 'Guadeloupe',
        value: 'Guadeloupe'
    }, {
        label: 'Guamanian',
        value: 'Guamanian'
    }, {
        label: 'Guatemalan',
        value: 'Guatemalan'
    }, {
        label: 'Guernsey',
        value: 'Guernsey'
    }, {
        label: 'Guinean',
        value: 'Guinean'
    }, {
        label: 'Guinean (Guinea)',
        value: 'Guinean (Guinea)'
    }, {
        label: 'Guyanese',
        value: 'Guyanese'
    }, {
        label: 'Haitian',
        value: 'Haitian'
    }, {
        label: 'Heard Island and McDonald Islands',
        value: 'Heard Island and McDonald Islands'
    }, {
        label: 'Honduran',
        value: 'Honduran'
    }, {
        label: 'Hong Kong Chinese',
        value: 'Hong Kong Chinese'
    }, {
        label: 'Hungarian',
        value: 'Hungarian'
    }, {
        label: 'Icelandic',
        value: 'Icelandic'
    }, {
        label: 'Indian',
        value: 'Indian'
    }, {
        label: 'Indonesian',
        value: 'Indonesian'
    }, {
        label: 'Iranian',
        value: 'Iranian'
    }, {
        label: 'Iraqi',
        value: 'Iraqi'
    }, {
        label: 'Isle of Man',
        value: 'Isle of Man'
    }, {
        label: 'Israeli',
        value: 'Israeli'
    }, {
        label: 'Italian',
        value: 'Italian'
    }, {
        label: 'Ivorian',
        value: 'Ivorian'
    }, {
        label: 'Jamaican',
        value: 'Jamaican'
    }, {
        label: 'Japanese',
        value: 'Japanese'
    }, {
        label: 'Jersey',
        value: 'Jersey'
    }, {
        label: 'Jordanian',
        value: 'Jordanian'
    }, {
        label: 'Kazakhstani',
        value: 'Kazakhstani'
    }, {
        label: 'Kenyan',
        value: 'Kenyan'
    }, {
        label: 'Kiribati',
        value: 'Kiribati'
    }, {
        label: 'Kosovar',
        value: 'Kosovar'
    }, {
        label: 'Kuwaiti',
        value: 'Kuwaiti'
    }, {
        label: 'Kyrgyzstani',
        value: 'Kyrgyzstani'
    }, {
        label: 'Kyrgyz',
        value: 'Kyrgyz'
    }, {
        label: 'Laotian',
        value: 'Laotian'
    }, {
        label: 'Latvian',
        value: 'Latvian'
    }, {
        label: 'Lebanese',
        value: 'Lebanese'
    }, {
        label: 'Liberian',
        value: 'Liberian'
    }, {
        label: 'Libyan',
        value: 'Libyan'
    }, {
        label: 'Liechtensteiner',
        value: 'Liechtensteiner'
    }, {
        label: 'Lithuanian',
        value: 'Lithuanian'
    }, {
        label: 'Luxembourgish',
        value: 'Luxembourgish'
    }, {
        label: 'Macanese',
        value: 'Macanese'
    }, {
        label: 'Macedonian',
        value: 'Macedonian'
    }, {
        label: 'Malagasy',
        value: 'Malagasy'
    }, {
        label: 'Malawian',
        value: 'Malawian'
    }, {
        label: 'Malaysian',
        value: 'Malaysian'
    }, {
        label: 'Maldivian',
        value: 'Maldivian'
    }, {
        label: 'Malian',
        value: 'Malian'
    }, {
        label: 'Maltese',
        value: 'Maltese'
    }, {
        label: 'Marshallese',
        value: 'Marshallese'
    }, {
        label: 'Martinican',
        value:	'Martinican'
    }, {
        label: 'Mauritanian',
        value: 'Mauritanian'
    }, {
        label: 'Mauritian',
        value: 'Mauritian'
    }, {
        label: 'Mexican',
        value: 'Mexican'
    }, {
        label: 'Micronesian',
        value: 'Micronesian'
    }, {
        label: 'Moldovan',
        value: 'Moldovan'
    }, {
        label: 'Monegasque',
        value: 'Monegasque'
    }, {
        label: 'Mongolian',
        value: 'Mongolian'
    }, {
        label: 'Montenegrin',
        value: 'Montenegrin'
    }, {
        label: 'Montserratian',
        value: 'Montserratian'
    }, {
        label: 'Moroccan',
        value: 'Moroccan'
    }, {
        label: 'Mozambican',
        value: 'Mozambican'
    }, {
        label: 'Myanmar',
        value: 'Myanmar'
    }, {
        label: 'Namibian',
        value: 'Namibian'
    }, {
        label: 'Nauruan',
        value: 'Nauruan'
    }, {
        label: 'Nepalese',
        value: 'Nepalese'
    }, {
        label: 'New Caledonian',
        value: 'New Caledonian'
    }, {
        label: 'New Zealand',
        value: 'New Zealand'
    }, {
        label: 'Nicaraguan',
        value: 'Nicaraguan'
    }, {
        label: 'Nigerian',
        value: 'Nigerian'
    }, {
        label: 'Nigerien',
        value: 'Nigerien'
    }, {
        label: 'Niuean',
        value: 'Niuean'
    }, {
        label: 'Norfolk Island',
        value: 'Norfolk Island'
    }, {
        label: 'North Korean',
        value: 'North Korean'
    }, {
        label: 'Northern Irish',
        value: 'Northern Irish'
    }, {
        label: 'Northern Mariana Island',
        value: 'Northern Mariana Island'
    }, {
        label: 'Norwegian',
        value: 'Norwegian'
    }, {
        label: 'Omani',
        value: 'Omani'
    }, {
        label: 'Pakistani',
        value: 'Pakistani'
    }, {
        label: 'Palauan',
        value: 'Palauan'
    }, {
        label: 'Palestinian',
        value: 'Palestinian'
    }, {
        label: 'Panamanian',
        value: 'Panamanian'
    }, {
        label: 'Papua New Guinean',
        value: 'Papua New Guinean'
    }, {
        label: 'Paraguayan',
        value: 'Paraguayan'
    }, {
        label: 'Peruvian',
        value: 'Peruvian'
    }, {
        label: 'Pitcairn Island',
        value: 'Pitcairn Island'
    }, {
        label: 'Polish',
        value: 'Polish'
    }, {
        label: 'Portuguese',
        value: 'Portuguese'
    }, {
        label: 'Puerto Rican',
        value: 'Puerto Rican'
    }, {
        label: 'Qatari',
        value: 'Qatari'
    }, {
        label: 'Réunionese',
        value: 'Réunionese'
    }, {
        label: 'Romanian',
        value: 'Romanian'
    }, {
        label: 'Russian',
        value: 'Russian'
    }, {
        label: 'Rwandan',
        value: 'Rwandan'
    }, {
        label: 'Saint Barthélemy',
        value: 'Saint Barthélemy'
    }, {
        label: 'Saint Helena',
        value: 'Saint Helena'
    }, {
        label: 'Saint Kitts and Nevis',
        value: 'Saint Kitts and Nevis'
    }, {
        label: 'Saint Lucian',
        value: 'Saint Lucian'
    }, {
        label: 'Saint Martin',
        value: 'Saint Martin'
    }, {
        label: 'Saint Pierre and Miquelon',
        value: 'Saint Pierre and Miquelon'
    }, {
        label: 'Saint Vincent and the Grenadines',
        value: 'Saint Vincent and the Grenadines'
    }, {
        label: 'Samoan',
        value: 'Samoan'
    }, {
        label: 'San Marinese',
        value: 'San Marinese'
    }, {
        label: 'São Toméan',
        value: 'São Toméan'
    }, {
        label: 'Saudi Arabian',
        value: 'Saudi Arabian'
    }, {
        label: 'Scottish',
        value: 'Scottish'
    }, {
        label: 'Senegalese',
        value: 'Senegalese'
    }, {
        label: 'Serbian',
        value: 'Serbian'
    }, {
        label: 'Seychellois',
        value: 'Seychellois'
    }, {
        label: 'Sierra Leonean',
        value: 'Sierra Leonean'
    }, {
        label: 'Singaporean',
        value: 'Singaporean'
    }, {
        label: 'Sint Eustatian',
        value: 'Sint Eustatian'
    }, {
        label: 'Sint Maarten',
        value: 'Sint Maarten'
    }, {
        label: 'Slovak',
        value: 'Slovak'
    }, {
        label: 'Slovenian',
        value: 'Slovenian'
    }, {
        label: 'Solomon Island',
        value: 'Solomon Island'
    }, {
        label: 'Somali',
        value: 'Somali'
    }, {
        label: 'South African',
        value: 'South African'
    }, {
        label: 'South Georgia and the South Sandwich Islands',
        value: 'South Georgia and the South Sandwich Islands'
    }, {
        label: 'South Korean',
        value: 'South Korean'
    }, {
        label: 'South Sudanese',
        value: 'South Sudanese'
    }, {
        label: 'Spanish',
        value: 'Spanish'
    }, {
        label: 'Sri Lankan',
        value: 'Sri Lankan'
    }, {
        label: 'Sudanese',
        value: 'Sudanese'
    }, {
        label: 'Surinamese',
        value: 'Surinamese'
    }, {
        label: 'Svalbard',
        value: 'Svalbard'
    }, {
        label: 'Swedish',
        value: 'Swedish'
    }, {
        label: 'Swiss',
        value: 'Swiss'
    }, {
        label: 'Syrian',
        value: 'Syrian'
    }, {
        label: 'Taiwanese',
        value: 'Taiwanese'
    }, {
        label: 'Tajikistani',
        value: 'Tajikistani'
    }, {
        label: 'Tajik',
        value: 'Tajik'
    }, {
        label: 'Tanzanian',
        value: 'Tanzanian'
    }, {
        label: 'Thai',
        value: 'Thai'
    }, {
        label: 'Timorese',
        value: 'Timorese'
    }, {
        label: 'Togolese',
        value: 'Togolese'
    }, {
        label: 'Tokelauan',
        value: 'Tokelauan'
    }, {
        label: 'Tongan',
        value: 'Tongan'
    }, {
        label: 'Trinidadian or Tobagonian',
        value: 'Trinidadian or Tobagonian'
    }, {
        label: 'Tunisian',
        value: 'Tunisian'
    }, {
        label: 'Turkish',
        value: 'Turkish'
    }, {
        label: 'Turkmen',
        value: 'Turkmen'
    }, {
        label: 'Turks and Caicos Island',
        value: 'Turks and Caicos Island'
    }, {
        label: 'Tuvaluan',
        value: 'Tuvaluan'
    }, {
        label: 'Ugandan',
        value: 'Ugandan'
    }, {
        label: 'Ukrainian',
        value: 'Ukrainian'
    }, {
        label: 'Uruguayan',
        value: 'Uruguayan'
    }, {
        label: 'Uzbekistani',
        value: 'Uzbekistani'
    }, {
        label: 'Venezuelan',
        value: 'Venezuelan'
    }, {
        label: 'Vietnamese',
        value: 'Vietnamese'
    }, {
        label: 'Vincentian',
        value: 'Vincentian'
    }, {
        label: 'Virgin Island',
        value: 'Virgin Island'
    }, {
        label: 'Welsh',
        value: 'Welsh'
    }, {
        label: 'Wallis and Futuna',
        value: 'Wallis and Futuna'
    }, {
        label: 'West Timorese',
        value: 'West Timorese'
    }, {
        label: 'Yemeni',
        value: 'Yemeni'
    }, {
        label: 'Zambian',
        value: 'Zambian'
    }, {
        label: 'Zimbabwean',
        value: 'Zimbabwean'
    }, {
        label: 'Åland Island',
        value: 'Åland Island'
    }
];

export const COUNTRY_OPTIONS = [
    {
        value: "AFG",
        label: "Afghanistan"
    },
    {
        value: "ALA",
        label: "Åland Islands"
    },
    {
        value: "ALB",
        label: "Albania"
    },
    {
        value: "DZA",
        label: "Algeria"
    },
    {
        value: "ASM",
        label: "American Samoa"
    },
    {
        value: "AND",
        label: "Andorra"
    },
    {
        value: "AGO",
        label: "Angola"
    },
    {
        value: "AIA",
        label: "Anguilla"
    },
    {
        value: "ATA",
        label: "Antarctica"
    },
    {
        value: "ATG",
        label: "Antigua and Barbuda"
    },
    {
        value: "ARG",
        label: "Argentina"
    },
    {
        value: "ARM",
        label: "Armenia"
    },
    {
        value: "ABW",
        label: "Aruba"
    },
    {
        value: "AUS",
        label: "Australia"
    },
    {
        value: "AUT",
        label: "Austria"
    },
    {
        value: "AZE",
        label: "Azerbaijan"
    },
    {
        value: "BHS",
        label: "Bahamas"
    },
    {
        value: "BHR",
        label: "Bahrain"
    },
    {
        value: "BGD",
        label: "Bangladesh"
    },
    {
        value: "BRB",
        label: "Barbados"
    },
    {
        value: "BLR",
        label: "Belarus"
    },
    {
        value: "BEL",
        label: "Belgium"
    },
    {
        value: "BLZ",
        label: "Belize"
    },
    {
        value: "BEN",
        label: "Benin"
    },
    {
        value: "BMU",
        label: "Bermuda"
    },
    {
        value: "BTN",
        label: "Bhutan"
    },
    {
        value: "BOL",
        label: "Bolivia"
    },
    {
        value: "BES",
        label: "Bonaire, Sint Eustatius and Saba"
    },
    {
        value: "BIH",
        label: "Bosnia and Herzegovina"
    },
    {
        value: "BWA",
        label: "Botswana"
    },
    {
        value: "BVT",
        label: "Bouvet Island"
    },
    {
        value: "BRA",
        label: "Brazil"
    },
    {
        value: "IOT",
        label: "British Indian Ocean Territory"
    },
    {
        value: "BRN",
        label: "Brunei"
    },
    {
        value: "BGR",
        label: "Bulgaria"
    },
    {
        value: "BFA",
        label: "Burkina Faso"
    },
    {
        value: "BDI",
        label: "Burundi"
    },
    {
        value: "CPV",
        label: "Cabo Verde"
    },
    {
        value: "KHM",
        label: "Cambodia"
    },
    {
        value: "CMR",
        label: "Cameroon"
    },
    {
        value: "CAN",
        label: "Canada"
    },
    {
        value: "CYM",
        label: "Cayman Islands"
    },
    {
        value: "CAF",
        label: "Central African Republic"
    },
    {
        value: "TCD",
        label: "Chad"
    },
    {
        value: "CHL",
        label: "Chile"
    },
    {
        value: "CHN",
        label: "China"
    },
    {
        value: "CXR",
        label: "Christmas Island"
    },
    {
        value: "CCK",
        label: "Cocos (Keeling) Islands"
    },
    {
        value: "COL",
        label: "Colombia"
    },
    {
        value: "COM",
        label: "Comoros"
    },
    {
        value: "COG",
        label: "Congo"
    },
    {
        value: "COD",
        label: "Congo (Democratic Republic)"
    },
    {
        value: "COK",
        label: "Cook Islands"
    },
    {
        value: "CRI",
        label: "Costa Rica"
    },
    {
        value: "CIV",
        label: "Côte d'Ivoire"
    },
    {
        value: "HRV",
        label: "Croatia"
    },
    {
        value: "CUB",
        label: "Cuba"
    },
    {
        value: "CUW",
        label: "Curaçao"
    },
    {
        value: "CYP",
        label: "Cyprus"
    },
    {
        value: "CZE",
        label: "Czech Republic"
    },
    {
        value: "DNK",
        label: "Denmark"
    },
    {
        value: "DJI",
        label: "Djibouti"
    },
    {
        value: "DMA",
        label: "Dominica"
    },
    {
        value: "DOM",
        label: "Dominican Republic"
    },
    {
        value: "ECU",
        label: "Ecuador"
    },
    {
        value: "EGY",
        label: "Egypt"
    },
    {
        value: "SLV",
        label: "El Salvador"
    },
    {
        value: "GNQ",
        label: "Equatorial Guinea"
    },
    {
        value: "ERI",
        label: "Eritrea"
    },
    {
        value: "EST",
        label: "Estonia"
    },
    {
        value: "ETH",
        label: "Ethiopia"
    },
    {
        value: "FLK",
        label: "Falkland Islands (Malvinas)"
    },
    {
        value: "FRO",
        label: "Faroe Islands"
    },
    {
        value: "FJI",
        label: "Fiji"
    },
    {
        value: "FIN",
        label: "Finland"
    },
    {
        value: "FRA",
        label: "France"
    },
    {
        value: "GUF",
        label: "French Guiana"
    },
    {
        value: "PYF",
        label: "French Polynesia"
    },
    {
        value: "ATF",
        label: "French Southern Territories"
    },
    {
        value: "GAB",
        label: "Gabon"
    },
    {
        value: "GMB",
        label: "Gambia"
    },
    {
        value: "GEO",
        label: "Georgia"
    },
    {
        value: "DEU",
        label: "Germany"
    },
    {
        value: "GHA",
        label: "Ghana"
    },
    {
        value: "GIB",
        label: "Gibraltar"
    },
    {
        value: "GRC",
        label: "Greece"
    },
    {
        value: "GRL",
        label: "Greenland"
    },
    {
        value: "GRD",
        label: "Grenada"
    },
    {
        value: "GLP",
        label: "Guadeloupe"
    },
    {
        value: "GUM",
        label: "Guam"
    },
    {
        value: "GTM",
        label: "Guatemala"
    },
    {
        value: "GGY",
        label: "Guernsey"
    },
    {
        value: "GIN",
        label: "Guinea"
    },
    {
        value: "GNB",
        label: "Guinea-Bissau"
    },
    {
        value: "GUY",
        label: "Guyana"
    },
    {
        value: "HTI",
        label: "Haiti"
    },
    {
        value: "HMD",
        label: "Heard Island and McDonald Islands"
    },
    {
        value: "VAT",
        label: "Holy See"
    },
    {
        value: "HND",
        label: "Honduras"
    },
    {
        value: "HKG",
        label: "Hong Kong"
    },
    {
        value: "HUN",
        label: "Hungary"
    },
    {
        value: "ISL",
        label: "Iceland"
    },
    {
        value: "IND",
        label: "India"
    },
    {
        value: "IDN",
        label: "Indonesia"
    },
    {
        value: "IRN",
        label: "Iran"
    },
    {
        value: "IRQ",
        label: "Iraq"
    },
    {
        value: "IRL",
        label: "Ireland"
    },
    {
        value: "IMN",
        label: "Isle of Man"
    },
    {
        value: "ISR",
        label: "Israel"
    },
    {
        value: "ITA",
        label: "Italy"
    },
    {
        value: "JAM",
        label: "Jamaica"
    },
    {
        value: "JPN",
        label: "Japan"
    },
    {
        value: "JEY",
        label: "Jersey"
    },
    {
        value: "JOR",
        label: "Jordan"
    },
    {
        value: "KAZ",
        label: "Kazakhstan"
    },
    {
        value: "KEN",
        label: "Kenya"
    },
    {
        value: "KIR",
        label: "Kiribati"
    },
    {
        value: "PRK",
        label: "Korea (Democratic People's Republic of)"
    },
    {
        value: "KOR",
        label: "Korea (Republic of)"
    },
    {
        value: "KWT",
        label: "Kuwait"
    },
    {
        value: "KGZ",
        label: "Kyrgyzstan"
    },
    {
        value: "LAO",
        label: "Laos"
    },
    {
        value: "LVA",
        label: "Latvia"
    },
    {
        value: "LBN",
        label: "Lebanon"
    },
    {
        value: "LSO",
        label: "Lesotho"
    },
    {
        value: "LBR",
        label: "Liberia"
    },
    {
        value: "LBY",
        label: "Libya"
    },
    {
        value: "LIE",
        label: "Liechtenstein"
    },
    {
        value: "LTU",
        label: "Lithuania"
    },
    {
        value: "LUX",
        label: "Luxembourg"
    },
    {
        value: "MAC",
        label: "Macao"
    },
    {
        value: "MKD",
        label: "Macedonia"
    },
    {
        value: "MDG",
        label: "Madagascar"
    },
    {
        value: "MWI",
        label: "Malawi"
    },
    {
        value: "MYS",
        label: "Malaysia"
    },
    {
        value: "MDV",
        label: "Maldives"
    },
    {
        value: "MLI",
        label: "Mali"
    },
    {
        value: "MLT",
        label: "Malta"
    },
    {
        value: "MHL",
        label: "Marshall Islands"
    },
    {
        value: "MTQ",
        label: "Martinique"
    },
    {
        value: "MRT",
        label: "Mauritania"
    },
    {
        value: "MUS",
        label: "Mauritius"
    },
    {
        value: "MYT",
        label: "Mayotte"
    },
    {
        value: "MEX",
        label: "Mexico"
    },
    {
        value: "FSM",
        label: "Micronesia"
    },
    {
        value: "MDA",
        label: "Moldova"
    },
    {
        value: "MCO",
        label: "Monaco"
    },
    {
        value: "MNG",
        label: "Mongolia"
    },
    {
        value: "MNE",
        label: "Montenegro"
    },
    {
        value: "MSR",
        label: "Montserrat"
    },
    {
        value: "MAR",
        label: "Morocco"
    },
    {
        value: "MOZ",
        label: "Mozambique"
    },
    {
        value: "MMR",
        label: "Myanmar"
    },
    {
        value: "NAM",
        label: "Namibia"
    },
    {
        value: "NRU",
        label: "Nauru"
    },
    {
        value: "NPL",
        label: "Nepal"
    },
    {
        value: "NLD",
        label: "Netherlands"
    },
    {
        value: "NCL",
        label: "New Caledonia"
    },
    {
        value: "NZL",
        label: "New Zealand"
    },
    {
        value: "NIC",
        label: "Nicaragua"
    },
    {
        value: "NER",
        label: "Niger"
    },
    {
        value: "NGA",
        label: "Nigeria"
    },
    {
        value: "NIU",
        label: "Niue"
    },
    {
        value: "NFK",
        label: "Norfolk Island"
    },
    {
        value: "MNP",
        label: "Northern Mariana Islands"
    },
    {
        value: "NOR",
        label: "Norway"
    },
    {
        value: "OMN",
        label: "Oman"
    },
    {
        value: "PAK",
        label: "Pakistan"
    },
    {
        value: "PLW",
        label: "Palau"
    },
    {
        value: "PSE",
        label: "Palestine"
    },
    {
        value: "PAN",
        label: "Panama"
    },
    {
        value: "PNG",
        label: "Papua New Guinea"
    },
    {
        value: "PRY",
        label: "Paraguay"
    },
    {
        value: "PER",
        label: "Peru"
    },
    {
        value: "PHL",
        label: "Philippines"
    },
    {
        value: "PCN",
        label: "Pitcairn"
    },
    {
        value: "POL",
        label: "Poland"
    },
    {
        value: "PRT",
        label: "Portugal"
    },
    {
        value: "PRI",
        label: "Puerto Rico"
    },
    {
        value: "QAT",
        label: "Qatar"
    },
    {
        value: "REU",
        label: "Réunion"
    },
    {
        value: "ROU",
        label: "Romania"
    },
    {
        value: "RUS",
        label: "Russian Federation"
    },
    {
        value: "RWA",
        label: "Rwanda"
    },
    {
        value: "BLM",
        label: "Saint Barthélemy"
    },
    {
        value: "SHN",
        label: "Saint Helena, Ascension and Tristan da Cunha"
    },
    {
        value: "KNA",
        label: "Saint Kitts and Nevis"
    },
    {
        value: "LCA",
        label: "Saint Lucia"
    },
    {
        value: "MAF",
        label: "Saint Martin"
    },
    {
        value: "SPM",
        label: "Saint Pierre and Miquelon"
    },
    {
        value: "VCT",
        label: "Saint Vincent and the Grenadines"
    },
    {
        value: "WSM",
        label: "Samoa"
    },
    {
        value: "SMR",
        label: "San Marino"
    },
    {
        value: "STP",
        label: "Sao Tome and Principe"
    },
    {
        value: "SAU",
        label: "Saudi Arabia"
    },
    {
        value: "SEN",
        label: "Senegal"
    },
    {
        value: "SRB",
        label: "Serbia"
    },
    {
        value: "SYC",
        label: "Seychelles"
    },
    {
        value: "SLE",
        label: "Sierra Leone"
    },
    {
        value: "SGP",
        label: "Singapore"
    },
    {
        value: "SXM",
        label: "Sint Maarten"
    },
    {
        value: "SVK",
        label: "Slovakia"
    },
    {
        value: "SVN",
        label: "Slovenia"
    },
    {
        value: "SLB",
        label: "Solomon Islands"
    },
    {
        value: "SOM",
        label: "Somalia"
    },
    {
        value: "ZAF",
        label: "South Africa"
    },
    {
        value: "SGS",
        label: "South Georgia and the South Sandwich Islands"
    },
    {
        value: "SSD",
        label: "South Sudan"
    },
    {
        value: "ESP",
        label: "Spain"
    },
    {
        value: "LKA",
        label: "Sri Lanka"
    },
    {
        value: "SDN",
        label: "Sudan"
    },
    {
        value: "SUR",
        label: "Suriname"
    },
    {
        value: "SJM",
        label: "Svalbard and Jan Mayen"
    },
    {
        value: "SWZ",
        label: "Swaziland"
    },
    {
        value: "SWE",
        label: "Sweden"
    },
    {
        value: "CHE",
        label: "Switzerland"
    },
    {
        value: "SYR",
        label: "Syria"
    },
    {
        value: "TWN",
        label: "Taiwan"
    },
    {
        value: "TJK",
        label: "Tajikistan"
    },
    {
        value: "TZA",
        label: "Tanzania"
    },
    {
        value: "THA",
        label: "Thailand"
    },
    {
        value: "TLS",
        label: "Timor-Leste"
    },
    {
        value: "TGO",
        label: "Togo"
    },
    {
        value: "TKL",
        label: "Tokelau"
    },
    {
        value: "TON",
        label: "Tonga"
    },
    {
        value: "TTO",
        label: "Trinidad and Tobago"
    },
    {
        value: "TUN",
        label: "Tunisia"
    },
    {
        value: "TUR",
        label: "Turkey"
    },
    {
        value: "TKM",
        label: "Turkmenistan"
    },
    {
        value: "TCA",
        label: "Turks and Caicos Islands"
    },
    {
        value: "TUV",
        label: "Tuvalu"
    },
    {
        value: "UGA",
        label: "Uganda"
    },
    {
        value: "UKR",
        label: "Ukraine"
    },
    {
        value: "ARE",
        label: "United Arab Emirates"
    },
    {
        value: "GBR",
        label: "United Kingdom"
    },
    {
        value: "USA",
        label: "United States"
    },
    {
        value: "UMI",
        label: "United States Minor Outlying Islands"
    },
    {
        value: "URY",
        label: "Uruguay"
    },
    {
        value: "UZB",
        label: "Uzbekistan"
    },
    {
        value: "VUT",
        label: "Vanuatu"
    },
    {
        value: "VEN",
        label: "Venezuela"
    },
    {
        value: "VNM",
        label: "Viet Nam"
    },
    {
        value: "VGB",
        label: "Virgin Islands (British)"
    },
    {
        value: "VIR",
        label: "Virgin Islands (U.S.)"
    },
    {
        value: "WLF",
        label: "Wallis and Futuna"
    },
    {
        value: "ESH",
        label: "Western Sahara"
    },
    {
        value: "YEM",
        label: "Yemen"
    },
    {
        value: "ZMB",
        label: "Zambia"
    },
    {
        value: "ZWE",
        label: "Zimbabwe"
    }
];


export const DEFAULT_ERROR_MESSAGE      = 'An error occurred. Please refresh the page to try again. If the problem persists, please contact support.';
export const SE_PRIVACY_POLICY          = 'https://gorilla-qa.akoni.io/static/privacy';
export const SE_BE_TERMS_AND_CONDITIONS = 'https://gorilla-qa.akoni.io/static/t&c';
